// Setup-screen strings (English) — split out of messages.ts so each
// locale table lives in its own file; merged in ./messages.ts.

export const setupEn = {
  'setup.title': 'New game',
  'setup.back': 'Back to menu',
  'setup.quickStart': 'Quick start',
  'setup.quickStartLabel': 'Quick start: play {name} right away',
  'setup.who': "Who's playing?",
  'setup.whoHint': 'Pick the rules that fit the player. You can fine-tune everything below.',
  'setup.ageBadge': '{age}+',
  'setup.ageLabel': 'For ages {age} and up',
  'setup.sessionMin': '{min}–{max} min',
  'setup.sessionHours': '{min}–{max} h',
  'setup.selected': 'Selected',
  'setup.custom': 'Custom (based on {name})',
  'setup.reset': 'Reset to {name}',

  'setup.preset.explorer': 'Explorer',
  'setup.preset.explorer.tagline': 'A perfect first adventure',
  'setup.preset.explorer.b1': 'Tiny map with one friendly neighbour',
  'setup.preset.explorer.b2': 'Win by reaching fun milestones',
  'setup.preset.explorer.b3': 'Lots of help and no game over',
  'setup.preset.apprentice': 'Apprentice',
  'setup.preset.apprentice.tagline': 'Learn the ropes',
  'setup.preset.apprentice.b1': 'Small map with two easy rivals',
  'setup.preset.apprentice.b2': 'Adds fog of war, roads and faith',
  'setup.preset.apprentice.b3': 'Five peaceful minutes to settle in',
  'setup.preset.standard': 'Standard',
  'setup.preset.standard.tagline': 'The full game, fairly paced',
  'setup.preset.standard.b1': 'Doctrines, magic and research',
  'setup.preset.standard.b2': 'Three rivals on a medium map',
  'setup.preset.standard.b3': 'Win by conquest, wealth, science or faith',
  'setup.preset.strategist': 'Strategist',
  'setup.preset.strategist.tagline': 'Every system, hard rivals',
  'setup.preset.strategist.b1': 'All rules except mature themes',
  'setup.preset.strategist.b2': 'Four hard rivals on a large map',
  'setup.preset.strategist.b3': 'Full diplomacy, spies and naval war',
  'setup.preset.grand': 'Grand Dominion',
  'setup.preset.grand.tagline': 'For seasoned rulers',
  'setup.preset.grand.b1': 'Every rule, mature themes included',
  'setup.preset.grand.b2': 'Six brutal rivals at a brisk pace',
  'setup.preset.grand.b3': 'No truces and no hints',
  'setup.preset.highlands': 'Highlands',
  'setup.preset.highlands.tagline': 'The land itself is the opponent',
  'setup.preset.highlands.b1': 'Terrain rises in levels — hold the high ground',
  'setup.preset.highlands.b2': 'Defenders on peaks take quarter damage',
  'setup.preset.highlands.b3': 'Peaks stay wild — found towns below level 8',
  'setup.preset.legends': 'Champions',
  'setup.preset.legends.tagline': 'One legend to turn the war',
  'setup.preset.legends.b1': 'Summon a Dragon with a doctrine and a long project',
  'setup.preset.legends.b2': 'Archers and towers shoot flyers harder',
  'setup.preset.legends.b3': 'If it falls, pay less to bring it back',
  'setup.preset.seafarers': 'Seafarers',
  'setup.preset.seafarers.tagline': 'Rule the waves',
  'setup.preset.seafarers.b1': 'Build trade ships and sail them between ports',
  'setup.preset.seafarers.b2': 'Load cargo at your harbour, sell it abroad',
  'setup.preset.seafarers.b3': 'Ports and sea lanes pay for themselves',
  'setup.preset.royal-houses': 'Royal Houses',
  'setup.preset.royal-houses.tagline': 'Marry for the crown',
  'setup.preset.royal-houses.b1': 'Every seat has a royal court — a woman and a man',
  'setup.preset.royal-houses.b2': 'Marriages bind alliances; breaking one costs honour',
  'setup.preset.royal-houses.b3': 'The AI weighs a marriage and offers one of its own',
  'setup.preset.royal-houses.b4': 'Children are born, heirs grow up, and a dead line adopts',
  'setup.preset.royal-houses.b5':
    'Your spies sabotage, assassinate and poison — and counter-spies watch for it',
  'setup.climate': 'Climate',
  'setup.climate.temperate': 'Temperate',
  'setup.climate.arctic': 'Arctic',
  'setup.climate.tropical': 'Tropical',
  'setup.climate.desert': 'Desert',
  'setup.sea': 'Sea',
  'setup.sea.desc':
    'Rim keeps the coast ring; Landlocked walls the map in mountains (no ports, no ships); Open adds deep ocean; Archipelago is islands (Circular shapes only).',
  'setup.sea.rim': 'Rim',
  'setup.sea.landlocked': 'Landlocked',
  'setup.sea.open': 'Open sea',
  'setup.sea.archipelago': 'Archipelago',
  'setup.thirst': 'Thirst',
  'setup.thirst.desc':
    'Units carry a canteen and take damage only when it runs dry. Auto turns it on from AI difficulty 3 (Normal).',
  'setup.thirst.auto': 'Auto',
  'setup.thirst.on': 'On',
  'setup.thirst.off': 'Off',
  'setup.yearLength': 'Year length',
  'setup.yearLength.desc':
    'Real minutes per in-game year — how fast the clock, the seasons and (in royal games) the dynasties run. 6 is the classic pace; 2 is a brisk saga, 12 a slow one. Fixed once the match starts.',

  'setup.customize': 'Customize',
  'setup.customizeHint': 'Rules, world, players and content',
  'setup.tabs': 'Customize the match',
  'setup.tab.rules': 'Rules',
  'setup.tab.world': 'World',
  'setup.tab.players': 'Players',
  'setup.tab.content': 'Content',
  'setup.core': 'Always on: cities, units, movement, combat, food and gold.',

  'setup.cat.economy': 'Economy',
  'setup.cat.doctrine': 'Doctrines',
  'setup.cat.heroes': 'Heroes',
  'setup.cat.combat': 'Combat',
  'setup.cat.faith': 'Faith',
  'setup.cat.magic': 'Magic',
  'setup.cat.science': 'Science',
  'setup.cat.diplomacy': 'Diplomacy',
  'setup.cat.espionage': 'Espionage',
  'setup.cat.world': 'World',
  'setup.cat.mature': 'Mature themes',
  'setup.cat.pacing': 'Pacing',
  'setup.cat.victory': 'Ways to win',
  'setup.cat.sea': 'Sea',

  'setup.module.economy.upkeep': 'Upkeep',
  'setup.module.economy.upkeep.desc': 'Units and heroes cost gold every turn',
  'setup.module.economy.upkeep.kid': 'Soldiers need gold to stay',
  'setup.module.economy.starvation': 'Starvation',
  'setup.module.economy.starvation.desc': 'Cities shrink when food runs out',
  'setup.module.economy.starvation.kid': 'Cities need food to grow',
  'setup.module.economy.supply': 'Depots & convoys',
  'setup.module.economy.supply.desc': 'Armies are supplied from depots by convoy',
  'setup.module.economy.supply.kid': 'Wagons carry food to your army',
  'setup.module.economy.roads': 'Roads',
  'setup.module.economy.roads.desc': 'Build roads to move faster',
  'setup.module.economy.roads.kid': 'Roads make trips quicker',
  'setup.module.economy.trade_routes': 'Trade routes',
  'setup.module.economy.trade_routes.desc': 'Link cities for a steady income',
  'setup.module.economy.trade_routes.kid': 'Cities trade and earn gold',
  'setup.module.diplomacy.dynasty': 'Royal marriages',
  'setup.module.diplomacy.dynasty.desc': 'Seal alliances by marrying into a royal family',
  'setup.module.diplomacy.dynasty.kid': 'Royal families marry to become friends',
  'setup.module.sea.trade': 'Trade ships',
  'setup.module.sea.trade.desc': 'Sail cargo between harbours for profit',
  'setup.module.sea.trade.kid': 'Ships carry goods to distant ports',
  'setup.module.doctrine.enabled': 'Doctrines',
  'setup.module.doctrine.enabled.desc': 'Invest in six schools of thought',
  'setup.module.doctrine.enabled.kid': 'Choose what your people believe in',
  'setup.module.heroes.enabled': 'Heroes',
  'setup.module.heroes.enabled.desc': 'Recruit heroes with special abilities',
  'setup.module.heroes.enabled.kid': 'Heroes with super powers',
  'setup.module.heroes.loyalty': 'Hero loyalty',
  'setup.module.heroes.loyalty.desc': 'Unhappy heroes may defect',
  'setup.module.heroes.loyalty.kid': 'Keep your heroes happy',
  'setup.module.heroes.captivity': 'Hero captivity',
  'setup.module.heroes.captivity.desc': 'A defeated hero may be taken prisoner',
  'setup.module.heroes.captivity.kid': 'You can catch a hero who loses a fight',
  'setup.module.heroes.quests': 'Hero orders',
  'setup.module.heroes.quests.desc': 'Give your heroes an order, and pay them when it is done',
  'setup.module.heroes.quests.kid': 'Tell a hero what to do and give them a treat',
  'setup.module.espionage.ops': 'Spy orders',
  'setup.module.espionage.ops.desc': 'Order your spies and assassins to strike an enemy city',
  'setup.module.espionage.ops.kid': 'Send a sneaky spy to break something',
  'setup.module.espionage.false_flag': 'False flags',
  'setup.module.espionage.false_flag.desc': 'Blame another house for what your spies do',
  'setup.module.espionage.false_flag.kid': 'Make someone else take the blame',
  'setup.module.espionage.counter_intel': 'Counter-intelligence',
  'setup.module.espionage.counter_intel.desc':
    'Post counter-spies, sweep for hidden agents, catch them, and see through false flags',
  'setup.module.espionage.counter_intel.kid': 'Catch the sneaky spies',
  'setup.module.diplomacy.generations': 'Generations',
  'setup.module.diplomacy.generations.desc':
    'Royal children, ageing and succession — houses continue across a lifetime',
  'setup.module.diplomacy.generations.kid': 'Royal children grow up and take over',
  'setup.module.combat.formations': 'Formations',
  'setup.module.combat.formations.desc': 'Arrange armies for bonuses',
  'setup.module.combat.formations.kid': 'Line up your army in clever shapes',
  'setup.module.combat.siege': 'Siege',
  'setup.module.combat.siege.desc': 'Siege engines and walled cities',
  'setup.module.combat.siege.kid': 'Big machines that break walls',
  'setup.module.combat.naval': 'Naval',
  'setup.module.combat.naval.desc': 'Ships, harbours and war at sea',
  'setup.module.combat.naval.kid': 'Sail ships across the sea',
  'setup.module.faith.enabled': 'Faith',
  'setup.module.faith.enabled.desc': 'Generate faith, sanctify land and heal',
  'setup.module.faith.enabled.kid': 'Temples that help your people',
  'setup.module.faith.crises': 'Faith crises',
  'setup.module.faith.crises.desc': 'Religious tension can boil over',
  'setup.module.faith.crises.kid': 'Sometimes people argue about beliefs',
  'setup.module.magic.enabled': 'Magic & mana',
  'setup.module.magic.enabled.desc': 'Mages, spells and ley lines',
  'setup.module.magic.enabled.kid': 'Cast magic spells',
  'setup.module.magic.rituals': 'Rituals',
  'setup.module.magic.rituals.desc': 'Long, powerful group spells',
  'setup.module.magic.rituals.kid': 'Giant spells that take time',
  'setup.module.science.research': 'Research',
  'setup.module.science.research.desc': 'Spend knowledge on breakthroughs',
  'setup.module.science.research.kid': 'Discover new ideas',
  'setup.module.diplomacy.basic': 'War & peace',
  'setup.module.diplomacy.basic.desc': 'Declare war and make peace',
  'setup.module.diplomacy.basic.kid': 'Make friends or fight',
  'setup.module.diplomacy.full': 'Treaties & vassals',
  'setup.module.diplomacy.full.desc': 'Alliances, vassals, federations and tribute',
  'setup.module.diplomacy.full.kid': 'Make deals with other rulers',
  'setup.module.espionage.enabled': 'Spies & sabotage',
  'setup.module.espionage.enabled.desc': 'Spy, sabotage and stir up revolts',
  'setup.module.espionage.enabled.kid': 'Sneaky spies',
  'setup.module.world.neutrals': 'Bandits & pirates',
  'setup.module.world.neutrals.desc': 'Neutral raiders and independent towns',
  'setup.module.world.neutrals.kid': 'Robbers roam the land',
  'setup.module.world.ruins': 'Ruins & treasure',
  'setup.module.world.ruins.desc': 'Explore ruins for rewards',
  'setup.module.world.ruins.kid': 'Find hidden treasure',
  'setup.module.world.fog_of_war': 'Fog of war',
  'setup.module.world.fog_of_war.desc': 'You only see what your units see',
  'setup.module.world.fog_of_war.kid': 'Explore to uncover the map',
  'setup.module.mature.slavery': 'Slaves & revolts',
  'setup.module.mature.slavery.desc': 'Enslave captives and risk revolts',
  'setup.module.mature.slavery.kid': 'Not for young players',
  'setup.module.mature.sacrifice': 'Sacrifice',
  'setup.module.mature.sacrifice.desc': 'Blood rites and blood priests',
  'setup.module.mature.sacrifice.kid': 'Not for young players',
  'setup.module.pacing.truce': 'Truces',
  'setup.module.pacing.truce.desc': 'A breather after big battles',
  'setup.module.pacing.truce.kid': 'A short rest after a big fight',
  'setup.module.pacing.intensity': 'Intensity limit',
  'setup.module.pacing.intensity.desc': 'Rivals ease off when pressure peaks',
  'setup.module.pacing.intensity.kid': 'Rivals slow down if it gets too hard',
  'setup.module.victory.conquest': 'Conquest victory',
  'setup.module.victory.conquest.desc': 'Take every rival capital',
  'setup.module.victory.conquest.kid': 'Win by capturing cities',
  'setup.module.victory.economic': 'Economic victory',
  'setup.module.victory.economic.desc': 'Build the richest empire',
  'setup.module.victory.economic.kid': 'Win by being the richest',
  'setup.module.victory.science': 'Science victory',
  'setup.module.victory.science.desc': 'Reach the final breakthroughs',
  'setup.module.victory.science.kid': 'Win with clever discoveries',
  'setup.module.victory.faith': 'Faith victory',
  'setup.module.victory.faith.desc': 'Spread your faith across the world',
  'setup.module.victory.faith.kid': 'Win by sharing your beliefs',
  'setup.module.victory.diplomatic': 'Diplomatic victory',
  'setup.module.victory.diplomatic.desc': 'Lead a federation of nations',
  'setup.module.victory.diplomatic.kid': 'Win by making friends',
  'setup.module.victory.milestones': 'Milestone victory',
  'setup.module.victory.milestones.desc': 'Reach goals like founding cities or recruiting a hero',
  'setup.module.victory.milestones.kid': 'Win by reaching fun goals',
  'setup.module.terrain.levels': 'Terrain levels',
  'setup.module.terrain.levels.desc': 'Height rises in levels — high ground matters',
  'setup.module.terrain.levels.kid': 'Mountains and valleys that really tower',
  'setup.authored.title': 'Play an authored map',
  'setup.authored.desc':
    'Import a map made in AOD Studio (an aod-map JSON file). The board comes from the map; the rules stay yours to set.',
  'setup.authored.import': 'Import a map',
  'setup.authored.clear': 'Remove the map',
  'setup.authored.problems': '{count} problems with this map',
  'setup.authored.invalid': 'That does not look like an AOD map',
  'setup.cat.map': 'Map',
  'setup.module.map.custom': 'Authored map',
  'setup.module.map.custom.desc':
    'Set automatically when you play a map made in AOD Studio. No effect in a normal match.',
  'setup.module.map.custom.kid': 'For maps made in AOD Studio',
  'setup.module.legends.enabled': 'Champions',
  'setup.module.legends.enabled.desc':
    'Earn one legendary creature — a Dragon — by a long summoning project',
  'setup.module.legends.enabled.kid': 'Call a giant dragon to fight for you',

  'setup.alsoOff': 'Turning off {name} also turns off {list}.',
  'setup.alsoOn': 'Turning on {name} also turns on {list}.',
  'setup.needs': 'Needs {list}',
  'setup.lockedFamily': 'Off under the Family rating',
  'setup.undo': 'Undo',

  'setup.problems': 'Fix before starting',
  'setup.problemCount': 'Fix the rules to start',
  'setup.problem.needs': '{module} needs {dependency}',
  'setup.problem.noVictory': 'Pick at least one way to win',
  'setup.problem.family': 'The Family rating excludes mature themes',
  'setup.problem.aiRange': 'Pick 1 to 7 AI opponents',
  'setup.problem.peaceRange': 'The peace period must be 0–20 min',
  'setup.problem.truceRange': 'A truce must be 0–5 min',
  'setup.problem.unknown': 'Unknown rule: {id}',

  'setup.minutes': '{min} min',
  'setup.off': 'Off',
  'setup.tuning.pace': 'Pace',
  'setup.tuning.pace.relaxed': 'Relaxed',
  'setup.tuning.pace.normal': 'Normal',
  'setup.tuning.pace.brisk': 'Brisk',
  'setup.tuning.mapSize': 'Map size',
  'setup.tuning.mapSize.tiny': 'Tiny',
  'setup.tuning.mapSize.small': 'Small',
  'setup.tuning.mapSize.medium': 'Medium',
  'setup.tuning.mapSize.large': 'Large',
  'setup.tuning.startingResources': 'Starting resources',
  'setup.tuning.startingResources.low': 'Low',
  'setup.tuning.startingResources.normal': 'Normal',
  'setup.tuning.startingResources.high': 'High',
  'setup.tuning.victoryLength': 'Match length',
  'setup.tuning.victoryLength.short': 'Short',
  'setup.tuning.victoryLength.normal': 'Normal',
  'setup.tuning.victoryLength.long': 'Long',
  'setup.tuning.peacePeriod': 'Peace period',
  'setup.tuning.peacePeriod.desc': 'No rival attacks you before this',
  'setup.tuning.cityCanBeDestroyed': 'Last city can fall',
  'setup.tuning.cityCanBeDestroyed.desc': 'When off, you get a refuge instead of losing early',
  'setup.tuning.truceMin': 'Truce length',
  'setup.tuning.truceMin.desc': 'A pause in fighting after a decisive battle',
  'setup.tuning.intensityCeiling': 'Rival pressure limit',
  'setup.tuning.intensityCeiling.low': 'Low',
  'setup.tuning.intensityCeiling.medium': 'Medium',
  'setup.tuning.intensityCeiling.high': 'High',
  'setup.tuning.intensityCeiling.off': 'No limit',
  'setup.decrease': 'Less {label}',
  'setup.increase': 'More {label}',

  'setup.players.rivals': 'Rivals',
  'setup.players.opponents': 'AI opponents',
  'setup.players.profile': 'AI difficulty',
  'setup.players.profile.gentle': 'Gentle',
  'setup.players.profile.easy': 'Easy',
  'setup.players.profile.normal': 'Normal',
  'setup.players.profile.hard': 'Hard',
  'setup.players.profile.brutal': 'Brutal',
  'setup.players.you': 'Your assists',
  'setup.players.youHint': 'Help for you only. Rivals play by the same rules.',
  'setup.players.alignment': 'Alignment',
  'setup.players.alignment.desc': 'Picks your cities’ starting doctrine path.',
  'setup.players.alignment.none': 'Unaligned',
  'setup.players.alignment.light': 'Light',
  'setup.players.alignment.dark': 'Dark',
  'setup.assist.handicap': 'Head start',
  'setup.assist.handicap.none': 'None',
  'setup.assist.handicap.easy': 'Some',
  'setup.assist.handicap.very_easy': 'Lots',
  'setup.assist.autoManageCities': 'City helper',
  'setup.assist.autoManageCities.off': 'Off',
  'setup.assist.autoManageCities.suggest': 'Suggest',
  'setup.assist.autoManageCities.auto': 'Auto',
  'setup.assist.hints': 'Hints',
  'setup.assist.hints.off': 'Off',
  'setup.assist.hints.smart': 'Smart',
  'setup.assist.hints.always': 'Always',
  'setup.assist.revealMap': 'Reveal the whole map',
  'setup.assist.pauseOnDanger': 'Pause on danger',
  'setup.assist.pauseOnDanger.off': 'Off',
  'setup.assist.pauseOnDanger.major': 'Big threats',
  'setup.assist.pauseOnDanger.all': 'Any attack',
  'setup.assist.uiMode': 'Interface',
  'setup.assist.uiMode.icons': 'Icons',
  'setup.assist.uiMode.standard': 'Standard',
  'setup.assist.uiMode.expert': 'Expert',
  'setup.assist.speedCap': 'Top speed',

  'setup.content.label': 'Content rating',
  'setup.content.family': 'Family',
  'setup.content.family.desc': 'No mature themes. Gentler names and effects.',
  'setup.content.teen': 'Teen',
  'setup.content.teen.desc': 'Mature themes are off, but you can turn them on.',
  'setup.content.mature': 'Mature',
  'setup.content.mature.desc': 'Everything is available, including slavery and sacrifice.',

  'setup.share.label': 'Share code',
  'setup.share.hint': 'Send it to a friend so they can play the same rules.',
  'setup.share.copy': 'Copy share code',
  'setup.share.copied': 'Copied',
  'setup.share.input': 'Have a code? Paste it here',
  'setup.share.apply': 'Use code',
  'setup.share.applied': 'Code loaded',
  'setup.share.error.format': "That doesn't look like a share code",
  'setup.share.error.checksum': 'A character looks mistyped',
  'setup.share.error.version': 'This code is from a newer version of the game',
  'setup.share.error.value': "This code's settings don't fit together",
  'setup.share.error.invalid': "This code's settings don't fit together",

  'setup.summary.label': 'Match summary',
  'setup.summary.map.tiny': 'tiny map',
  'setup.summary.map.small': 'small map',
  'setup.summary.map.medium': 'medium map',
  'setup.summary.map.large': 'large map',
  'setup.summary.ai.one': '1 {profile} AI',
  'setup.summary.ai.other': '{count} {profile} AIs',
  'setup.summary.profile.gentle.one': 'gentle',
  'setup.summary.profile.gentle.other': 'gentle',
  'setup.summary.profile.easy.one': 'easy',
  'setup.summary.profile.easy.other': 'easy',
  'setup.summary.profile.normal.one': 'normal',
  'setup.summary.profile.normal.other': 'normal',
  'setup.summary.profile.hard.one': 'hard',
  'setup.summary.profile.hard.other': 'hard',
  'setup.summary.profile.brutal.one': 'brutal',
  'setup.summary.profile.brutal.other': 'brutal',
  'setup.summary.minutes': '~{min} min',
  'setup.summary.hours': '~{hours} h',
  'setup.start': 'Start',
  'setup.startLabel': 'Start the match: {summary}',
} as const;

export type SetupMessageKey = keyof typeof setupEn;
